import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';

import { Header } from '@/components';

export function Auth() {
  return (
    <Layout>
      <Header includeSetting={false} />
      <Layout.Content className="place-items-center">
        <Outlet />
      </Layout.Content>
    </Layout>
  );
}
